<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `annexes/testEquipment/${inputs.id}`
            : `annexes/testEquipment/`
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>EQUIPO (NOMBRE, MODELO, FABRICANTE)</label>
              <app-input
                type="textarea"
                v-model="inputs.equipment"
                placeholder="Ingrese el nombre, modelo, fabricante del equipo"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>RANGO, CAPACIDAD Y OTRA INFORMACIÓN IMPORTANTE</label>
              <app-input
                type="textarea"
                v-model="inputs.description"
                placeholder="Ingrese la descripcion del equipo"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>FECHA DE PUESTA EN SERVICIO Y ULTIMA CALIBRACIÓN</label>
              <app-input
                type="date"
                v-model="inputs.date_service"
                placeholder="Ingrese una fecha valida"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "TestEquipmentModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      modalTitle: "Añadir Equipo de Ensayo",
      disabledSubmit: false,
    };
  },
  created() {
    this.inputs.date_service = new Date(Date.now());
    if (this.selectedUrl) {
      this.modalTitle = "Editar Equipo de Ensayo";
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      const tmp = { ...this.inputs };
      tmp.accreditation_application_id = this.$store.state.accreditation.id;
      const d = tmp.date_service;
      tmp.date_service = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join(
        "-"
      );
      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.inputs.date_service = new Date(response.data.date_service);
      this.preloader = false;
    },
  },
};
</script>
